module.exports = __webpack_public_path__ + "static/media/primoAlberoGenealogico1960.f9b02cda.jpg";